import { useContext } from 'react';
import { FeatureContext } from './FeatureContext';

/**
 * Returns the current feature context (config, data, actions).
 * Auto-resolves the feature from the current route — zero arguments.
 *
 * Returns `null` on non-feature routes.
 */
export function useFeature() {
  return useContext(FeatureContext);
}
